export enum StrainExecutionMode {
    WithSimulation = 0,
    WithoutSimulation = 1,
}
